import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./blog.css";

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const API_BASE = "https://portfolio-backend-production-832f.up.railway.app/api";


const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState("All");
  const swiperRef = useRef(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await fetch(`${API_BASE}/blogs`); // backend endpoint
        const data = await res.json();
        setBlogs(data);
      } catch (err) {
        console.error("Error loading blogs:", err);
      }
    };

    fetchBlogs();
  }, []);

  const categories = ["All", ...new Set(blogs.map((b) => b.category))];

  const filteredBlogs =
    categoryFilter === "All"
      ? blogs
      : blogs.filter((b) => b.category === categoryFilter);

  const [featured, ...restBlogs] = filteredBlogs;

  return (
    <section className="blog-section" id="blog">
      <div className="blog-header">
        <h2>Blog</h2>
        <span>Latest Articles</span>
      </div>

      {/* Only show blog content if blogs exist */}
      {filteredBlogs.length > 0 ? (
        <>
          {/* Filter Buttons */}
          <div className="blog-filters">
            {categories.map((cat) => (
              <button
                key={cat}
                className={`filter-btn ${
                  categoryFilter === cat ? "active" : ""
                }`}
                onClick={() => setCategoryFilter(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Featured Blog */}
          <div className="blog-featured">
            <img src={featured.image} alt={featured.title} />
            <div className="blog-info">
              <span className="blog-date">{featured.date}</span>
              <h3>{featured.title}</h3>
              <p>{featured.summary}</p>
              <Link to={`/blog/${featured.id}`} className="blog-readmore">
                Read more
              </Link>
            </div>
          </div>

          {/* Blog Slider */}
          <Swiper
            ref={swiperRef}
            spaceBetween={20}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            pagination={{ clickable: true }}
            navigation={false} // default arrows removed
            modules={[Pagination, Navigation]}
            className="blog-slider"
          >
            {restBlogs.map(({ id, title, summary, image, date }) => (
              <SwiperSlide key={id}>
                <div className="blog-card">
                  <img src={image} alt={title} />
                  <div className="blog-info">
                    <span className="blog-date">{date}</span>
                    <h3>{title}</h3>
                    <p>{summary}</p>
                    <Link to={`/blog/${id}`} className="blog-readmore">
                      Read more
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom arrows outside the slider */}
          <div className="custom-arrows">
            <div
              className="arrow prev"
              onClick={() => swiperRef.current?.swiper.slidePrev()}
            >
              &larr;
            </div>
            <div
              className="arrow next"
              onClick={() => swiperRef.current?.swiper.slideNext()}
            >
              &rarr;
            </div>
          </div>
        </>
      ) : (
        <p className="no-blogs">No blogs available right now.</p>
      )}
    </section>
  );
};

export default Blog;
